import React from 'react';
import { Popup } from 'components/Popup/Popup';
import { useLocalStorage } from 'hooks/useLocalStorage';
import codeframesBannerImgSrc from 'assets/img/codeframes-featured-img.jpg';

export const HeyYabbleCountStepCodeframesAnnouncement: React.FC = () => {
  const [dismissedAt, saveDismissedAtDate] = useLocalStorage<string>(
    'yabble-csv-import-count-step-codeframes-popup-dismissed-at',
    null
  );

  return !dismissedAt ? (
    <Popup
      title="Introducing Codeframes"
      bannerImgSrc={codeframesBannerImgSrc}
      badgeProps={{
        label: 'New Feature',
        bgColor: 'blue500',
        bgColorAlpha: 0.08,
        color: 'blue500',
      }}
      footerActions={[
        {
          label: 'Try now',
          severity: 'secondary',
        },
      ]}
      onDismiss={() => {
        saveDismissedAtDate(new Date().toISOString());
      }}
    >
      Effortlessly categorize open-ended survey responses into structured themes, enhancing the depth and
      efficiency of your insights. Whether you're dealing with large volumes of qualitative data or seeking
      precise thematic breakdowns, Codeframes gives you flexibility and control at your fingertips.
    </Popup>
  ) : null;
};
